import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import MUITableCell from '@material-ui/core/TableCell';

// Style
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => {
  return {
    root: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
  };
};

class TableCell extends PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.node,
  };

  render() {
    let { children, ...otherProps } = this.props;

    return <MUITableCell {...otherProps}>{children}</MUITableCell>;
  }
}

export default withStyles(styles)(TableCell);
